import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { resolveTenantUrl, tenantOverrideOptions } from 'src/app/Common/ApiConfigurationService/resolve-tenant-url.util';
import {
    UserBranchSoftwareMapping_create,
    UserBranchSoftwareMapping_delete,
    UserBranchSoftwareMapping_readAll,
    UserBranchSoftwareMapping_readById,
    UserBranchSoftwareMapping_readByUserId,
    UserBranchSoftwareMapping_update
} from 'src/app/GlobalVariables';
import {
    UserBranchSoftwareMappingCreateRequestDTO,
    UserBranchSoftwareMappingDeleteRequestDTO,
    UserBranchSoftwareMappingDTO,
    UserBranchSoftwareMappingListDTO,
    UserBranchSoftwareMappingReadByIdRequestDTO,
    UserBranchSoftwareMappingReadByUserIdRequestDTO,
    UserBranchSoftwareMappingUpdateRequestDTO
} from './userbranchsoftwaremapping.interface';


@Injectable({
    providedIn: 'root'
})
export class UserBranchSoftwareMappingService {
    constructor(private http: HttpClient) { }

    UBSM_create(request: UserBranchSoftwareMappingCreateRequestDTO): Observable<UserBranchSoftwareMappingDTO> {
        return this.http.post<UserBranchSoftwareMappingDTO>(UserBranchSoftwareMapping_create, request);
    }

    UBSM_update(request: UserBranchSoftwareMappingUpdateRequestDTO): Observable<UserBranchSoftwareMappingDTO> {
        return this.http.post<UserBranchSoftwareMappingDTO>(UserBranchSoftwareMapping_update, request);
    }

    UBSM_delete(request: UserBranchSoftwareMappingDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(UserBranchSoftwareMapping_delete , request);
    }

    UBSM_getById(request: UserBranchSoftwareMappingReadByIdRequestDTO): Observable<UserBranchSoftwareMappingDTO> {
        return this.http.post<UserBranchSoftwareMappingDTO>(UserBranchSoftwareMapping_readById, request);
    }

    UBSM_getAll(): Observable<UserBranchSoftwareMappingListDTO> {
        return this.http.get<UserBranchSoftwareMappingListDTO>(UserBranchSoftwareMapping_readAll);
    }

    // baseUrlOverride (optional): the viewed tenant's own AM gateway origin,
    // e.g. CompanyDetailComponent.apiConfigOverride.AM (company-users tab).
    // Omitted for every other caller - behaves exactly as before.
    UBSM_ReadByUserId(request: UserBranchSoftwareMappingReadByUserIdRequestDTO, baseUrlOverride?: string, companyId?: string | number, branchId?: string | number): Observable<UserBranchSoftwareMappingListDTO> {
        return this.http.post<UserBranchSoftwareMappingListDTO>(resolveTenantUrl(UserBranchSoftwareMapping_readByUserId, baseUrlOverride), request, tenantOverrideOptions(baseUrlOverride, companyId ?? 0, branchId ?? 0));
    }
}
